import { useEffect, useState } from "react";
import { api, API, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, FileText, Download, ExternalLink } from "lucide-react";
import { toast } from "sonner";

const BACKEND_ORIGIN = API.replace(/\/api$/, "");

export default function ShopReceipt() {
  const [state, setState] = useState({ loading: true });
  const [stripeUrl, setStripeUrl] = useState(null);

  const load = async () => {
    try { const { data } = await api.get("/my/receipt"); setState({ loading: false, url: data.url, number: data.receiptNumber }); }
    catch (e) { setState({ loading: false, err: apiError(e.response?.data?.detail) }); }
    api.get("/my/stripe-charge").then((r) => setStripeUrl(r.data.receiptUrl)).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const download = () => window.open(BACKEND_ORIGIN + state.url, "_blank");

  if (state.loading) return <div className="py-16 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>;

  return (
    <div className="space-y-4" data-testid="shop-receipt">
      <div className="flex items-center gap-2">
        <FileText className="w-5 h-5 text-primary" />
        <div>
          <h2 className="font-heading text-lg font-bold">Activation receipt</h2>
          <p className="text-sm text-muted-foreground">Download the PDF invoice for your one-time setup fee.</p>
        </div>
      </div>
      {state.err ? (
        <div className="rounded-2xl border border-dashed border-border bg-card p-12 text-center text-muted-foreground" data-testid="shop-receipt-error">{state.err}</div>
      ) : (
        <div className="rounded-2xl border border-border bg-card p-6 flex items-center gap-4 flex-wrap" data-testid="shop-receipt-card">
          <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center"><FileText className="w-6 h-6 text-primary" /></div>
          <div className="flex-1 min-w-0">
            <div className="font-heading font-bold">Velopaths Partner — Activation fee receipt</div>
            <div className="text-sm text-muted-foreground">{state.number ? `Receipt ${state.number} · ` : ""}PDF invoice with itemized charges and payment reference.</div>
          </div>
          {stripeUrl && <Button variant="outline" onClick={() => window.open(stripeUrl, "_blank")} data-testid="shop-stripe-receipt"><ExternalLink className="w-4 h-4 mr-1" />Stripe receipt</Button>}
          <Button onClick={download} data-testid="shop-receipt-download"><Download className="w-4 h-4 mr-1" />Download PDF</Button>
        </div>
      )}
    </div>
  );
}
